/** Shared hit targets for Retail V1 admin shell icon chrome (Settings / Profile). */

export const ADMIN_SHELL_ICON_BUTTON_CLASS = [
  'inline-flex h-11 w-11 min-h-11 min-w-11 shrink-0 items-center justify-center rounded-lg',
  'border border-[var(--color-rail-card-border)] bg-[var(--color-an-surface)]',
  'text-[var(--color-an-text)]',
  'hover:bg-[var(--color-an-surface-hover)]',
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
  'focus-visible:outline-[var(--color-an-focus-ring)]',
].join(' ');
